import { truncateFlowyText } from '../../../../src/ai/agent/textTruncation';

const escapeStatusLabel = (value: string): string =>
	value
		.trim()
		.replace(/\s+/g, ' ')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/([\\`*_\[\]])/g, '\\$1');

const formatStatusNodeLabel = (label: string): string =>
	escapeStatusLabel(truncateFlowyText(label.trim() ? label : 'Untitled node'));

export const formatNodeAddedStatus = (labels: string[]): string => {
	const safeLabels = labels.map((label) => formatStatusNodeLabel(label));
	if (safeLabels.length === 1) {
		return `Added node: "${safeLabels[0]}"`;
	}
	return `Added ${safeLabels.length} nodes to the board\n\n${safeLabels
		.map((label) => `- ${label}`)
		.join('\n')}`;
};

export const formatPdfSeedAddedStatus = (title: string): string =>
	`Added PDF summary and insights for ${formatStatusNodeLabel(title.trim() ? title : 'PDF document')}`;

export const hasExpandableEventDetails = (content: string): boolean => content.includes('\n\n- ');

export const getEventStatusSummary = (content: string): string =>
	content.split('\n', 1)[0] || content;
